import React from "react";
import classes from "./index.module.css";

const ColorStrip: React.FC = () => {
  return (
    <div className={classes.root}>
      <div className={classes.redLine} />
      <div className={classes.yellowLine} />
      <div className={classes.blueLine} />
    </div>
  );
};

export default ColorStrip;
